import { Avatar, AvatarProps } from '@fluentui/react-components';
import cn from 'classnames';
import React, { forwardRef } from 'react';
import { useCss } from 'react-use';

export interface ColorAvatarProps extends Omit<AvatarProps, 'color'> {
  backgroundColor?: string;
  color?: string;
}

export const ColorAvatar = forwardRef<HTMLSpanElement, ColorAvatarProps>(
  ({ backgroundColor, color, size, shape, className, ...rest }, reference) => {
    const resolvedSize = size ?? 32;

    // Use Northstar font-size formula (size / 2.333) to match legacy avatar appearance
    const initialsStyles: Record<string, string | undefined> = {
      backgroundColor,
      color,
      fontSize: `${resolvedSize / 2.333}px`,
    };

    const generatedClassName = useCss({
      'span.fui-Avatar__initials': initialsStyles,
      ...(shape === 'square' && {
        borderRadius: '3px !important',
        'span.fui-Avatar__initials': {
          ...initialsStyles,
          borderRadius: '3px !important',
        },
      }),
    });

    return (
      <Avatar
        className={cn(className, backgroundColor && generatedClassName)}
        shape={shape}
        {...rest}
        size={resolvedSize}
        ref={reference}
      />
    );
  },
);
